import React from 'react';
import { TableCell, TableSortLabel } from '@mui/material';

const SortableHeaderCell = ({ field, sort, align, children }) => (
    <TableCell align={align} sortDirection={sort.orderBy === field ? sort.order : false}>
        <TableSortLabel
            active={sort.orderBy === field}
            direction={sort.orderBy === field ? sort.order : 'asc'}
            onClick={() => sort.handleRequestSort(field)}
        >
            {children}
        </TableSortLabel>
    </TableCell>
);

export default SortableHeaderCell;
